
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2021-02-21-yarn-workspace",
      function () {
        return require("private-next-pages/blogs/2021-02-21-yarn-workspace/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2021-02-21-yarn-workspace"])
      });
    }
  